import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Card,
  CardImg,
  CardGroup,
  Row,
  Col
} from "reactstrap";
import {
  getPrescriptionByStatus,
  dispensePrescription,
  getPrescriptionByNumber
} from "../../actions/mqttAction";
import decode from "jwt-decode";
import VideoComponent from "./VideoComponent";
import Spinner from "../common/Spinner";

class PharmaStoreComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prescriptionToReview: {},
      roomInfo: ""
    }
    if (this.props.prescriptionNumber) {
      this.dispensePrescription = this.dispensePrescription.bind(this);
    }
  }

  componentDidMount() {
    let orgID;
    localStorage.orgID ? (orgID = localStorage.orgID) : (orgID = 1);
    if (this.props.prescriptionNumber) {
      let branchName;
      if ("TECHNICIAN" === this.props.auth.user.roles[0].toUpperCase()) {
        this.props.getPrescriptionByStatus(orgID, branchName, "CounsellingPending");
      } else {
        console.log('getPrescriptionByNumber :>> ', this.props.branchInfo);
        console.log('this.props.roomInfo :>> ', this.props.roomInfo);
        this.props.getPrescriptionByNumber(orgID, `branchName=${this.props.branchInfo}`, this.props.prescriptionNumber, this.props.branchInfo === 'Mora' ? "CounsellingPending" : "Dispensed");
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let prescriptionToReview = {}
    if (this.props.prescriptionNumber) {
      prescriptionToReview = this.props.mqtt.prescriptionByNumber
    }
    this.setState({
      ...this.state,
      prescriptionToReview,
      roomInfo: this.props.roomInfo
    });
  }
  dispensePrescription() {
    let orgId = 1;
    let prescription = Array.of(this.state.prescriptionToReview);
    // prescription.rxInfo.rxStatus = "Dispensed"
    prescription.map(
      prescription => {
        prescription.rxInfo.rxStatus = "Dispensed"; prescription.prescriptionStatus = "Dispensed"
        return prescription
      }
    );
    this.props.dispensePrescription(orgId, prescription, this.props.history);
  }

  render() {
    const { getPrescriptionByStatus, getPrescriptionByNumber, loading } = this.props.mqtt;
    let verifyIdentity, reviewPrescription, ndcImage, videoView;
    let isTechnician = this.props.auth.user.roles[0].toUpperCase() == 'TECHNICIAN'
    let patientData;
    let reviewPrescriptionInfo;
    // console.log('this.props.auth.user :>> ', isTechnician);
    if (loading && this.props.prescriptionNumber) {
      verifyIdentity = <Spinner />;
      reviewPrescription = <Spinner />;
    } else {
      if (isTechnician && Object.keys(getPrescriptionByStatus).length > 0) {
        reviewPrescriptionInfo = getPrescriptionByStatus[0];
        patientData = getPrescriptionByStatus[0].patientInfo;
        videoView = (<VideoComponent dispensePrescription={this.dispensePrescription} />);
      } else {
        if (this.props.mqtt.prescriptionByNumber) {
          reviewPrescriptionInfo = this.state.prescriptionToReview
          console.log('getPrescriptionByNumber :>> ', getPrescriptionByNumber);
          patientData = reviewPrescriptionInfo.patientInfo;
        }
      }
      if (this.props.prescriptionNumber && !isTechnician && JSON.stringify(reviewPrescriptionInfo.patientInfo)) {
        videoView = (<VideoComponent dispensePrescription={this.dispensePrescription} roomName={this.state.roomInfo} />);
        verifyIdentity = (
          <Card >
            <Row style={{
              marginLeft: "10%", marginRight: "10%",
              backgroundColor: "lightgrey", borderColor: "#333",
              paddingTop: "0.1rem", paddingBottom: "0.1rem"
            }}>

              <Col className="text-left" >
                <h1 className="text-info">
                  {patientData.firstName} {patientData.lastName}
                </h1>
                DOB : {patientData.dateOfBirth}
                <hr />

                <Row style={{
                  marginLeft: "0.1rem",
                  marginTop: "1rem"
                }} >
                  <div style={{ fontWeight: "bold" }} >
                    <h4>{this.state.prescriptionToReview.rxInfo.rxName}</h4></div>
                  <div className="text-left" > Refills Remaining : {this.state.prescriptionToReview.rxInfo.maximumRefillsAllowed -
                    this.state.prescriptionToReview.rxInfo.currentRefillCount}</div>
                </Row>
                <Row style={{
                  marginLeft: "0.1rem",
                  marginTop: "0.1rem"
                }} >
                  <span style={{ fontWeight: "bold", marginRight: "0.1rem" }}>Quantitiy : </span> {this.state.prescriptionToReview.rxInfo.quantity}
                </Row>
                <Row style={{
                  marginLeft: "0.1rem",
                  marginTop: "0.1rem"
                }} >
                  <span style={{ fontWeight: "bold", marginRight: "0.1rem" }}>Strength :   </span> {this.state.prescriptionToReview.rxInfo.strength}
                </Row>
              </Col>
              <Col>
              </Col>
              <Col className="text-right">
                <h3>{patientData.address}</h3>
                Phone : {patientData.phoneNumber}
              </Col>

            </Row>
            {/* <Row>
              <div>
                <div> {this.state.prescriptionToReview.rxInfo.rxName}</div>
                <div>{this.state.prescriptionToReview.rxInfo.rxDirectionsToUse}</div>
                <div>
                  Refills Remaining :
                  {this.state.prescriptionToReview.rxInfo.maximumRefillsAllowed -
                    prescription.rxInfo.currentRefillCount}
                </div>
                <div>Quantitiy : {prescription.rxInfo.quantity}</div>
                <div>Strength : {prescription.rxInfo.strength}</div>
                <div>DateFilled : {prescription.rxInfo.dateFilled}</div>
              </div>
            </Row> */}
          </Card>
        );

        reviewPrescription = Array.of(this.state.prescriptionToReview).map(prescription => (
          <Card
            style={{
              borderRadius: "5px",
              paddingTop: "30px"
            }}
          >
            <Row key={prescription.rxInfo.prescriptionNumber}>
              <Col
                lg="9"
                style={{
                  paddingRight: "0px"
                }}
              >
                <CardGroup>
                  <Card
                    style={{
                      width: "600px",
                      height: "600px"
                    }}
                  >
                    <CardImg
                      src={prescription.prescriptionImageUrls[3].imageUrl}
                      left
                      style={{
                        width: "450px",
                        height: "400px"
                      }}
                    />
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Card>
        ));
        // reviewPrescription = getPrescriptionByStatus.map(prescription => (

        // ));
      } else if (!this.props.prescriptionNumber && !isTechnician) {
        reviewPrescription = <div> Call from branch</div>
        console.log('this.props.destinationName :>> ', this.props.destinationName);
        videoView = <VideoComponent isManualDial="true" roomName={this.state.roomInfo} />
      } else {
        reviewPrescription = (
          <h3 className="text-center">No Prescription to Pickup...</h3>
        );
      }
    }
    return (
      !isTechnician ? (<div>
        <Row>
          <Col
            style={{
              borderRadius: "5px",
              padding: "30px"
            }}
          >
            {verifyIdentity}
          </Col>
        </Row>
        <Row >
          <Col
            style={{
              borderRadius: "5px",
              paddingLeft: "30px",
              marginLeft: "7%"
            }}
          >
            {reviewPrescription}
          </Col>
          <Col>
            {videoView}
          </Col>
        </Row>
      </div>) : (Object.keys(getPrescriptionByStatus).length > 0 ? (<div>
        <section>
          <img style={{ display: "flex", maxWidth: "47%", marginLeft: "23%", alignItems: "center", justifyContent: "center" }}
            src={require("../../assets/img/image_bestcare.png")} /></section>
        <div> <h3 className="text-center">Prescription Ready to Pickup, Click "Contact My Pharmacist" to Continue... </h3></div>
        <section>{videoView}</section>
      </div>) : (<div><img style={{ display: "flex", maxWidth: "57%", marginLeft: "23%", alignItems: "center", justifyContent: "center" }}
        src={require("../../assets/img/image_bestcare.png")} />
        <section><h2 className="text-center">No Prescriptions to Pickup...</h2></section></div>))
    );
  }
}

PharmaStoreComponent.propTypes = {
  mqtt: PropTypes.object.isRequired,
  getPrescriptionByStatus: PropTypes.func.isRequired,
  getPrescriptionByNumber: PropTypes.func.isRequired,
  dispensePrescription: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  mqtt: state.mqtt,
  auth: state.auth,
  roles: state.auth.user.roles,
});

export default connect(mapStateToProps, {
  getPrescriptionByNumber,
  getPrescriptionByStatus,
  dispensePrescription
})(PharmaStoreComponent);
